module.exports = __webpack_public_path__ + "img/notariuszio.f161cfe6.jpg";